"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SortedSet;

var _Set = _interopRequireDefault(require("./Set"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/SortedSet.html
 *
 * @extends {Set}
 * @constructor
 * @private
 */
function SortedSet() {}

;
SortedSet.prototype = new _Set.default();